<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
export default {
    name: 'App',
    components: {}
}
</script>

<style>
@import '../static/styles/style.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue